
import { useState } from 'react';
import { useTranslation } from 'react-i18next';

interface FaqItem {
  question: string;
  answer: string;
}

export default function FaqSection() {
  const { t } = useTranslation();
  const [openIndex, setOpenIndex] = useState<number | null>(0);

  const faqs: FaqItem[] = [
    {
      question: '料金はいつ支払うのですか？',
      answer: '初期費用は契約時に、運営代行手数料は毎月の売上から自動的に差し引かれます。追加サービスは利用時に別途ご請求となります。'
    },
    {
      question: '最低契約期間はありますか？',
      answer: '基本的に6ヶ月からの契約となります。ただし、物件の状況やご希望に応じて柔軟に対応いたしますので、まずはご相談ください。'
    },
    {
      question: '途中で解約できますか？',
      answer: 'はい、可能です。契約期間満了の1ヶ月前までにご連絡いただければ、違約金なしで解約できます。契約期間中の解約については、個別にご相談させていただきます。'
    },
    {
      question: '運営代行手数料以外に追加費用はかかりますか？',
      answer: '基本的な運営業務は手数料に含まれています。ただし、清掃代行、リネン交換、プライベートドライバーなどの追加サービスをご利用の場合は別途料金が発生します。'
    },
    {
      question: 'どのエリアの物件に対応していますか？',
      answer: '東京23区内を中心に対応しています。特に馬込・品川・目黒・渋谷エリアは重点対応エリアです。その他のエリアについてもご相談ください。'
    },
    {
      question: '民泊許可を持っていないのですが、サポートしてもらえますか？',
      answer: 'はい、民泊許可申請のサポートも行っています。必要書類の準備から申請代行まで、ワンストップでお手伝いいたします。詳しくは無料相談でご案内します。'
    },
    {
      question: '収益保証はありますか？',
      answer: '収益保証は行っておりませんが、過去の実績として平均稼働率92%、平均月間収益15〜25万円を達成しています。物件の条件により異なりますので、無料相談で詳しくシミュレーションいたします。'
    }
  ];

  return (
    <section className="py-24 bg-white">
      <div className="max-w-4xl mx-auto px-6">
        <div className="text-center mb-16">
          <h2 className="text-4xl font-bold text-gray-900 mb-4">
            よくある質問
          </h2>
          <p className="text-lg text-gray-600">
            料金や契約に関するご質問にお答えします
          </p>
        </div>

        <div className="space-y-4">
          {faqs.map((faq, index) => (
            <div
              key={index}
              className="border border-gray-200 rounded-xl overflow-hidden bg-white hover:shadow-md transition-shadow"
            >
              <button
                onClick={() => setOpenIndex(openIndex === index ? null : index)}
                className="w-full px-8 py-6 flex items-center justify-between text-left hover:bg-gray-50 transition-colors"
              >
                <span className="text-lg font-semibold text-gray-900 pr-8">
                  {faq.question}
                </span>
                <i
                  className={`ri-arrow-down-s-line text-2xl text-gray-600 transition-transform flex-shrink-0 ${
                    openIndex === index ? 'rotate-180' : ''
                  }`}
                ></i>
              </button>
              <div
                className={`overflow-hidden transition-all duration-300 ${
                  openIndex === index ? 'max-h-96' : 'max-h-0'
                }`}
              >
                <div className="px-8 pb-6 pt-2">
                  <p className="text-gray-700 leading-relaxed">{faq.answer}</p>
                </div>
              </div>
            </div>
          ))}
        </div>

        <div className="mt-12 text-center">
          <p className="text-gray-600 mb-6">
            その他のご質問がある場合は、お気軽にお問い合わせください
          </p>
          <a
            href="#contact"
            className="inline-flex items-center gap-2 px-8 py-4 bg-gray-900 text-white rounded-full font-semibold hover:bg-gray-800 transition-colors whitespace-nowrap cursor-pointer"
          >
            <i className="ri-question-line text-xl"></i>
            無料相談を予約する
          </a>
        </div>
      </div>
    </section>
  );
}
